/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDealerDetailsStats_reviews$ref: FragmentReference;
export type PdpSharedDealerDetailsStats_reviews = {|
  +metadata: ?{|
    +aggregatedFeedback: ?{|
      +overallExperience: ?{|
        +mean: ?number
      |}
    |}
  |},
  +$refType: PdpSharedDealerDetailsStats_reviews$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsStats_reviews",
  "type": "SellerOrderFeedbackPdpQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "metadata",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "aggregatedFeedback",
          "storageKey": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "overallExperience",
              "storageKey": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackQuestionType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "mean",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b4276a71d562f12cb1dc7bf883616ec7';
module.exports = node;
